import { Route } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { FirstLoginGuard } from 'app/core/auth/guards/first-login.guar';

export const homeRoutes: Route[] = [
    {
        path      : '',
        pathMatch : 'full',
        redirectTo: 'dashboard',
        canActivate:[FirstLoginGuard],
    },
    {
        path     : '',
        component: HomeComponent,
        children : [
            {
                path     : 'dashboard',                
                component: DashboardComponent,
                canActivate:[FirstLoginGuard],
                // resolve  : {

                // }
            }
        ]        
    }
];
